import PropTypes from "prop-types"

const UnfinalizedAttendees = ({ attendees }) => {
  return (
    <div className="staff-only alert info-alert">
      <div>Registrations with unfinalized attendees:</div>
      <ul>
        {attendees.map(attendee => (
          <li key={attendee.id}>
            <a href={attendee.registrationPath}>{attendee.id}</a>
          </li>
        ))}
      </ul>
    </div>
  )
}

UnfinalizedAttendees.propTypes = {
  attendees: PropTypes.array
}

export default UnfinalizedAttendees
